import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api-client';
import { Clock, ArrowRight } from 'lucide-react';

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState('All');
  useEffect(() => { api.getBlogPosts().then(setPosts); }, []);

  const categories = ['All', 'Updates', 'Tutorials', 'Case Studies'];
  const filtered = filter === 'All' ? posts : posts.filter(p => p.category === filter);

  return (
    <div className="bg-[#050505] min-h-screen pt-24">
      <section className="py-16 px-4">
        <div className="max-w-5xl mx-auto">
          <h1 data-testid="blog-title" className="text-4xl sm:text-5xl font-bold text-white mb-4 section-marker">Blog</h1>
          <p className="text-zinc-400 mb-8">Updates, tutorials, and case studies from the ClawStinger team.</p>
          <div className="flex gap-2 mb-8">
            {categories.map(c => (
              <button key={c} data-testid={`blog-filter-${c.toLowerCase()}`} onClick={() => setFilter(c)} className={`px-3 py-1.5 rounded-sm font-mono text-xs transition-all ${filter === c ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/30' : 'border border-zinc-800 text-zinc-500 hover:border-zinc-700'}`}>{c}</button>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filtered.map(post => (
              <Link key={post.id} to={`/blog/${post.slug}`} data-testid={`blog-post-${post.id}`} className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6 hover:border-zinc-700 transition-all group block">
                <div className="flex items-center gap-3 mb-3">
                  <span className="bg-emerald-500/10 text-emerald-400 text-xs font-mono px-2 py-0.5 rounded-sm border border-emerald-500/20">{post.category}</span>
                  <span className="text-xs font-mono text-zinc-600 flex items-center gap-1"><Clock size={10} /> {post.readTime}</span>
                </div>
                <h2 className="text-lg font-mono text-white font-bold mb-2 group-hover:text-emerald-400 transition-colors">{post.title}</h2>
                <p className="text-sm text-zinc-500 leading-relaxed mb-4">{post.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-mono text-zinc-600">{post.date}</span>
                  <span className="text-xs font-mono text-emerald-400 flex items-center gap-1 group-hover:gap-2 transition-all">Read more <ArrowRight size={12} /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
